module.exports = __webpack_public_path__ + "static/media/iconDownload.f11ff6d6.svg";